module.exports = __webpack_public_path__ + "public/Icons/verified.svg?f4e00342";